import { Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const LoginError = () => {
	const { logInError } = useSelector((state) => state.authSlice);

	return logInError ? (
		<Typography variant="p" component="p" color="glass.main">
			{logInError}
		</Typography>
	) : null;
};

LoginError.propTypes = {};

export default LoginError;
